export default {"src":"/_next/static/media/offers-to-likers.fd208298.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};